/** What the user sent, on the right. */
const UserMessage = ({ text }) => (
  <div className="flex justify-end" data-testid="agent-user-message">
    <div className="bg-primary/10 max-w-[85%] rounded-2xl rounded-br-md px-3.5 py-2 text-sm leading-6 whitespace-pre-wrap">{text}</div>
  </div>
);

export default UserMessage;
